import rtk /* , { select } */ from 'rtk'
import { createSelectorHooks } from 'rtk/react'
import { name } from './constants'
const { createSelectors } = rtk(name)

const selectors = createSelectors({
    location: state => state[name].location,
})

// RTK-AUTOEXPORT
// ---- selectors ---------
export const { selectLocation } = selectors
export const { useLocation } = createSelectorHooks(selectors)
